import { useCallback, useState } from 'react'
import { useMount, useUpdateEffect } from 'react-use'

import { allowEventTarget } from '@/utils/allowEventTarget'

const useKeyPressed = (
  key: string,
  onChangeStatus?: (status: boolean) => void
) => {
  const [pressed, setPressed] = useState<boolean>(false)

  const handleCommandKey = useCallback(
    (status: boolean) => (e: KeyboardEvent) => {
      if (e.key !== key) {
        return
      }

      // keyup is never skipped, otherwise the key stays pressed forever
      if (status && !allowEventTarget(e)) {
        return
      }

      setPressed(status)
    },
    []
  )

  useUpdateEffect(() => {
    onChangeStatus?.(pressed)
  }, [pressed])

  useMount(() => {
    const abortController = new AbortController()
    document.addEventListener('keydown', handleCommandKey(true), {
      signal: abortController.signal,
    })
    document.addEventListener('keyup', handleCommandKey(false), {
      signal: abortController.signal,
    })

    return abortController.abort
  })

  return pressed
}

export default useKeyPressed
